import * as React from 'react';
import loadable from '@loadable/component';
import { useApplicationContext } from '../../reactContext/applicationContext';

const GeoSwitcherContainerInnerLoadable = loadable(
  () => import(/* webpackChunkName: "GeoSwitcherContainerInnerLoadable" */ './loadable'),
  {
    ssr: false,
  },
);

export const GeoSwitcherWrapperContainer = () => {
  const context = useApplicationContext();
  const geoSwitcherEnabled = context.config?.get<boolean>('frontendMainPage.geoSwitcherEnabled') || false;

  if (!geoSwitcherEnabled) {
    return null;
  }

  return <GeoSwitcherContainerInnerLoadable />;
};
